import { render, staticRenderFns } from "./DirTargetItem.vue?vue&type=template&id=58faa0e3&scoped=true&"
import script from "./DirTargetItem.vue?vue&type=script&lang=js&"
export * from "./DirTargetItem.vue?vue&type=script&lang=js&"
import style0 from "./DirTargetItem.vue?vue&type=style&index=0&id=58faa0e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58faa0e3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
